// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useMemo} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import hola_opt from 'hola_opt';

type t_toolip_params = {
    category?: string,
    page?: string,
    per_page?: string,
    slug?: string,
    [propname:string]: string,
}

type t_hola_params = t_toolip_params;

export const get_aliased_pathname = (path, aliases?)=>{
    aliases = aliases||hola_opt.aliases;
    if (!aliases)
        return path;
    const alias = aliases.find(al=>al.url == path && !al.redirect);
    if (alias)
        return alias.original;
    for (const row of aliases)
    {
        if (row.redirect)
            continue;
        const pattern = row.url.replace(/:[^/]+/g, '([^/]+)');
        const regex = new RegExp(`^${pattern}/?$`);
        if (regex.test(path))
            return row.original;
    }
    return path;
};

export const get_pathname_for_redirect = (path, full_url?)=>{
    if (!hola_opt.aliases)
        return '';
    const full_alias = hola_opt.aliases.find(al=>al.original == full_url);
    if (full_alias)
        return full_alias.url;
    const alias = hola_opt.aliases.find(al=>al.original == path);
    if (alias)
        return alias.url;
    return '';
};

export const get_new_link = full_url=>{
    if (!hola_opt.aliases)
        return full_url;
    const alias = hola_opt.aliases.find(al=>al.original == full_url);
    if (alias)
        return alias.url;
    return full_url;
};

const rules = {
    toolip_io: [{
        url: '/blog',
        parse: url=>{
            if (url[url.length-1]=='/')
                url = url.slice(0, -1);
            const params_url = url.split('/').filter(s=>!!s);
            let params: t_toolip_params = {};
            for (let i = 1; i < params_url.length; i++)
            {
                if (params_url[i] == 'page' && !isNaN(+params_url[i+1]))
                {
                    params['page'] = params_url[i+1];
                    i++;
                }
                else if (params_url[i] == 'per_page' &&
                    !isNaN(+params_url[i+1]))
                {
                    params['per_page'] = params_url[i+1];
                    i++;
                }
                else if (i == 1 && params_url[i] != 'blog')
                    params['category'] = params_url[i];
                else
                    params['slug'] = params_url[i];
            }
            return params;
        },
        to_url: params=>{
            const {category, page, per_page, slug} = params;
            let url = '/blog';
            url += category ? `/${category}` : '';
            if (slug)
                return url + `/${slug}`;
            url += page && page != 1 ?`/page/${page}` : '';
            url += per_page ? `/per_page/${per_page}` : '';
            return url;
        },
    }],
    hola: [{
        url: '/blog',
        parse: url=>{
            if (url[url.length-1]=='/')
                url = url.slice(0, -1);
            const params_url = url.split('/').filter(s=>!!s);
            let params: t_hola_params = {};
            for (let i = 1; i < params_url.length; i++)
            {
                if (params_url[i] == 'page' && !isNaN(+params_url[i+1]))
                {
                    params['page'] = params_url[i+1];
                    i++;
                }
                else if (params_url[i] == 'per_page' &&
                    !isNaN(+params_url[i+1]))
                {
                    params['per_page'] = params_url[i+1];
                    i++;
                }
                else if (i == 1 && params_url[i])
                    params['category'] = params_url[i];
                else if (i == 2 && params_url[i])
                    params['slug'] = params_url[i];
            }
            return params;
        },
        to_url: params=>{
            const {category, page, per_page, slug} = params;
            let url = '/blog';
            url += category ? `/${category}` : '';
            if (slug)
                return url + `/${slug}`;
            url += page && page != 1 ?`/page/${page}` : '';
            url += per_page ? `/per_page/${per_page}` : '';
            return url;
        },
    }],
};

export const parse_pathname_to_params = pathname=>{
    const route_rules = location.host == 'toolip.io' ? rules.toolip_io
        : location.host == 'hola.org' ? rules.hola : [];
    for (let i = 0; i < route_rules.length; i++)
    {
        if (pathname.startsWith(route_rules[i].url))
            return route_rules[i].parse(pathname);
    }
    if (pathname[pathname.length-1]=='/')
        pathname = pathname.slice(0, -1);
    const params_url = pathname.split('/');
    const params = {} as object_of<string>;
    for (let i=params_url.length-1; i>=2; i--)
    {
        params[params_url[i-1]] = decodeURIComponent(params_url[i]);
        i--;
    }
    return params;
};

export const use_pathname = ()=>{
    const location = useLocation();
    const pathname_current = location.pathname;
    const pathname = get_aliased_pathname(pathname_current);
    const history = useHistory();
    const params = useMemo(()=>{
        return parse_pathname_to_params(pathname);
    }, [pathname]);
    const get_url = (new_params: object_of<string>)=>{
        let url = pathname;
        const route_rules = window.location.host == 'toolip.io' ?
            rules.toolip_io : window.location.host == 'hola.org' ?
            rules.hola : [];
        for (let i = 0; i < route_rules.length; i++)
        {
            if (url.startsWith(route_rules[i].url))
            {
                const current_params = route_rules[i].parse(url);
                return route_rules[i]
                    .to_url(Object.assign(current_params, new_params));
            }
        }
        const keys = Object.keys(new_params);
        keys.forEach(name=>{
            let new_url = '';
            const value = new_params[name];
            const params_url = url.split('/');
            if (!params_url[params_url.length-1])
                params_url.splice(-1);
            if (params[name])
            {
                for (let i=params_url.length-1; i>=1; i--)
                {
                    if (params_url[i-1]==name)
                    {
                        if (value)
                        {
                            new_url = `/${name}`+
                                `/${encodeURIComponent(value)}${new_url}`;
                        }
                    }
                    else
                    {
                        new_url = `/${params_url[i]}${new_url}`;
                        if (i > 1)
                            new_url = `/${params_url[i-1]}${new_url}`;
                    }
                    i--;
                }
            }
            else
            {
                if (value)
                {
                    new_url = `${url}`
                        +`/${name}/${encodeURIComponent(value)}`;
                }
                else
                    new_url = url;
            }
            for (;new_url.indexOf('//')>-1;)
                new_url = new_url.replace('//', '/');
            url = new_url;
        });
        const final_url = url.replace(/^\/\//, '/')||'/';
        return final_url + location.search + location.hash;
    };
    const set = (params_: object_of<string>)=>{
        const new_url = get_url(params_);
        const url = pathname + location.search + location.hash;
        if (new_url != url)
            history.push(new_url);
    };
    return {
        pathname: pathname,
        params,
        set,
        get_url,
    };
};
